import Component from '@bythepixel/component-loader';
import { DEFAULTS, STATES } from '@Front/components/customVideo/_config';
import { handleComponentError } from '@Core/helpers/functions';

export default class CustomVideo extends Component {
  static selector = `[${DEFAULTS.video}]`;

  constructor(containerEl, options = { ...DEFAULTS, ...STATES }) {
    super(containerEl, options);

    this.mount();
  }

  mount() {
    this.video = this.$container;
    this.playButton = document.querySelector(`[${this.$options.playButton}='${this.video.id}']`);
    this.muteButton = document.querySelector(`[${this.$options.muteButton}='${this.video.id}']`);

    handleComponentError([
      [this.video?.tagName !== 'VIDEO', 'Custom videos must use the <VIDEO> tag.'],
    ]);

    if (this.muteButton) {
      this.handleAudio();
    }

    if (this.playButton) {
      this.handlePlayback();
    }
  }

  handleAudio() {
    this.video.addEventListener('loadeddata', () => {
      const videoHasAudio = this.video.mozHasAudio
        || Boolean(this.video.webkitAudioDecodedByteCount)
        || Boolean(this.video.audioTracks?.length);

      if (!videoHasAudio) {
        this.muteButton.remove();
        return;
      }

      this.muteButton.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
      });

      this.video.addEventListener('volumechange', () => {
        this.muteButton.setAttribute(this.$options.muted, `${this.video.muted}`);
      });
    });
  }

  handlePlayback() {
    this.video.addEventListener('play', () => {
      this.playButton.setAttribute(this.$options.playing, 'true');

      if (this.video.getAttribute('data-comp-observee-callback') !== 'playbackOnView') {
        this.video.setAttribute('controls', '');
      }
    });

    this.video.addEventListener('pause', () => {
      this.playButton.setAttribute(this.$options.playing, 'false');
    });

    this.playButton.addEventListener('click', () => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });
  }
}
